import { SubscriptionData } from "./SubscriptionData";

export const DataPlan = () => {
  return (
    <div className="main-layout-container mx-3">
      <div className="main-panel">
        <SubscriptionData />
      </div>
    </div>
  );
};
